import styled from "styled-components";

export const DrawerButtonLayout = styled.div`
    display: grid;
    grid-auto-flow: column;
    gap: 2rem;
    justify-content: center;
`;
